import React, {Component, Fragment} from "react"
import styled from "styled-components"
import {InjectedIntl} from "react-intl"

import authentication from "@irati/auth"
import {H3, Body, Label} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import FormattedMessage, {injectIntl} from "@irati/utils/lang"
import padding from "@irati/ui/src/global/padding"
import theme from "@irati/ui/src/global/theme"

import EmojiWithText from "../EmojiWithText"
import {OnlineGPConsultationsTitle, PrescriptionServiceTitle, Tier1Info, Tier2Info, Tier3Info} from "./constants"

const Limits = styled.div`
  margin-top: ${padding.small};
`

const WrapperInsuranceButton = styled.div`
  margin-top: ${padding.small};
`

interface Point {
  emoji: string
  text: string
  isIcon?: boolean
}

interface Props extends InjectedIntl {
  title: string
}

class Popup extends Component<Props> {
  buildPopup = (title: string) => {
    const hasTier2Access = authentication.apps("medical.tiers.tier2")
    const hasTier3Access = authentication.apps("medical.tiers.tier3")

    if (hasTier3Access) {
      const insuranceItem = Tier3Info.find((info) => info.title === title)
      if (title === OnlineGPConsultationsTitle || title === PrescriptionServiceTitle) {
        return insuranceItem
      }
      return {...insuranceItem, terms: "medical.information.terms.3"}
    }
    if (hasTier2Access) {
      return Tier2Info.find((info) => info.title === title)
    }
    return Tier1Info.find((info) => info.title === title)
  }

  render() {
    const {title, formatMessage} = this.props
    const hasTier2Access = authentication.apps("medical.tiers.tier2")
    const {desc, points, terms, limits} = this.buildPopup(title)
    const hideFurtherInformation = title === OnlineGPConsultationsTitle || title === PrescriptionServiceTitle

    return (
      <Fragment>
        <H3 tiny>{formatMessage({id: title})}</H3>
        <Body large maxWidth="100%" marginBottom={1} weight="light">
          {hasTier2Access ? (
            <FormattedMessage id="medical.myMedical.popup.whatsIncluded.long" />
          ) : (
            <FormattedMessage id="medical.myMedical.popup.whatsIncluded.short" />
          )}
        </Body>
        <Hr />
        {desc &&
          desc.map((line: string) => (
            <Body key={`${title}-${line}`} small marginBottom={1}>
              {formatMessage({id: line})}
            </Body>
          ))}
        {desc && <Hr />}
        <Body small marginBottom={1} weight="bold">
          <FormattedMessage id="medical.myMedical.popup.whatIsCovered" />
        </Body>
        {points.map((point: Point) => (
          <EmojiWithText
            key={`emojiWithText-${point.text}`}
            emoji={point.emoji}
            isIcon={point.isIcon}
            text={formatMessage({id: point.text})}
          />
        ))}
        {limits && (
          <Limits>
            <Body small marginBottom={1} weight="bold">
              <FormattedMessage id="medical.myMedical.popup.limits" />
            </Body>
            {limits && (
              <Body small marginBottom={1}>
                {formatMessage({id: limits})}
              </Body>
            )}
          </Limits>
        )}
        <Label color={theme.colors.greys.mediumDark}>{formatMessage({id: terms})}</Label>
        {!hideFurtherInformation && (
          <WrapperInsuranceButton>
            <Body small marginBottom={1} weight="bold">
              <FormattedMessage id="medical.insurance.text" />
            </Body>
          </WrapperInsuranceButton>
        )}
      </Fragment>
    )
  }
}

export default injectIntl(Popup)
